export const BLANK_PLACEHOLDER = '[_]';
export const BLANK_TAG = '<span class="blank"></span>';

const blankTagPattern = /<span\s+class=(["'])blank\1><\/span>/gi;

export function contentToFormValue(content = '') {
    return content.replace(blankTagPattern, BLANK_PLACEHOLDER);
}

export function formValueToContent(content = '') {
    return content.replaceAll(BLANK_PLACEHOLDER, BLANK_TAG);
}

export function hasBlankPlaceholder(content = '') {
    return content.includes(BLANK_PLACEHOLDER);
}

export function getBlankPlaceholderCount(content = '') {
    return content.split(BLANK_PLACEHOLDER).length - 1;
}